var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.5 7.875A1.375 1.375 0 0 1 7.875 6.5h7.563a.687.687 0 0 0 .687-.687V2.375A1.375 1.375 0 0 0 14.75 1H2.375A1.375 1.375 0 0 0 1 2.375V14.75a1.375 1.375 0 0 0 1.375 1.375h3.438a.687.687 0 0 0 .687-.687z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.625 7.875H9.25c-.76 0-1.375.616-1.375 1.375v12.375c0 .76.616 1.375 1.375 1.375h12.375c.76 0 1.375-.616 1.375-1.375V9.25c0-.76-.616-1.375-1.375-1.375"
})));
export default SvgCopy;